'use strict'

import Contact from './Contact'
import File from './File'
import { Model } from '@vuex-orm/core'
import { createId } from '../utils'
import { capitalCase } from 'change-case'

export default class Account extends Model {
  static get entity () { return 'accounts' }

  static fields () {
    return {
      id: this.uid(() => createId()),
      name: this.string(),
      type: this.string(),
      subType: this.string(),
      referenceId: this.string(),
      notes: this.string(),
      description: this.string(),
      createdDate: this.string(),

      valuationDate: this.string(),
      currency: this.string('GBP'),
      value: this.number(),

      supplierId: this.attr(null),
      supplier: this.belongsTo(Contact, 'supplierId'),

      files: this.morphMany(File, 'ownerId', 'ownerType')
    }
  }

  get selectText () {
    return `${capitalCase(this.type)} - ${capitalCase(this.subType)} - ${this.name}`
  }
}
